import { create } from 'zustand';

import { IPartner } from '@/features/lp-village';

export type TSortBy = string;

interface ILPPartnershipStore {
  rowData: IPartner[];
  pageSize: number;
  offset: number;
  sortBy: TSortBy;
  order: 'ASC' | 'DESC';
  error: string | boolean;
  loading: boolean;
  count: number;
  dispatch: (args: TLPPartnershipReducerInput) => void;
  total: number;
}

type TLPPartnershipReducerInput =
  | {
      type: 'updateRowData';
      args: { rowData: any[] };
    }
  | {
      type: 'updateError';
      args: { error: string | boolean };
    }
  | {
      type: 'updateLoading';
      args: { loading: boolean };
    }
  | {
      type: 'updatePagination';
      args: { pageSize: number; offset: number };
    }
  | {
      type: 'updateSorting';
      args: {
        sortBy: TSortBy;
        order: 'ASC' | 'DESC';
      };
    }
  | {
      type: 'updateCount';
      args: { count: number };
    }
  | {
      type: 'updateTotal';
      args: { total: number };
    }
  | {
      type: 'reset';
    };

const lPPartnershipReducer = (
  state: ILPPartnershipStore,
  input: TLPPartnershipReducerInput
) => {
  switch (input.type) {
    case 'updateRowData':
      return { ...state, rowData: input.args.rowData };
    case 'updateError':
      return { ...state, error: input.args.error };
    case 'updateLoading':
      return { ...state, loading: input.args.loading };
    case 'updatePagination':
      return {
        ...state,
        pageSize: input.args.pageSize,
        offset: input.args.offset,
      };
    case 'updateSorting':
      return { ...state, sortBy: input.args.sortBy, order: input.args.order };
    case 'updateCount':
      return { ...state, count: input.args.count };
    case 'updateTotal':
      return { ...state, total: input.args.total };
    case 'reset':
      return INITIAL_STATE;
  }
};

const INITIAL_STATE: Omit<ILPPartnershipStore, 'dispatch'> = {
  rowData: [],
  error: '',
  loading: false,
  pageSize: 10,
  offset: 0,
  sortBy: 'updatedAt',
  order: 'DESC',
  count: 0,
  total: 0,
};

const usePartnershipStore = create<ILPPartnershipStore>((set) => ({
  ...INITIAL_STATE,
  dispatch: (input) => set((state) => lPPartnershipReducer(state, input)),
}));

export default usePartnershipStore;
